<template>
  <div class="tab-bar" :style="banner">
    <div class="banner">
      <div class="logo">
        <img
          src="../../../static/images/title.png"
          alt=""
          width="100%"
          height="100%"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "tabbar",
  data() {
    return {
      banner: {
        backgroundImage: "url(" + require("@/assets/icons/banner1.png") + ")",
        // backgroundImage: "",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        backgroundPosition: "center",
        position: "relative",
        height: "4rem",
        width: "100%",
        borderRadius: "0rem 0rem 0.267rem 0.267rem"
      },
      i: "0" //判断上下滑动
    };
  },
  methods: {
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(scrollTop)
      var offsetTop = document.querySelector(".el-tabs__header").offsetTop;
      var topBar = document.querySelector(".el-tabs__header");
      // console.log(offsetTop)
      var scroll = scrollTop - this.i;
      this.i = scrollTop;
      if (scrollTop > offsetTop - 3 && scroll > 0) {
        console.log("滑多了");
        topBar.style.position = "fixed";
        topBar.style.backgroundColor = "#fff";
        topBar.style.borderBottom = "none";
        document.querySelector(".el-tabs__content").style.paddingTop = "2rem";
      } else if (
        150 < scrollTop &&
        scrollTop <= 160 &&
        offsetTop === 0 &&
        scroll < 0
      ) {
        // console.log("ffff")
        topBar.style.position = "relative";
        topBar.style.backgroundColor = "transparent";
        topBar.style.borderBottom = "1px solid #f1f1f1";
        document.querySelector(".el-tabs__content").style.paddingTop = "0";
      } else if (scrollTop <= 150 && offsetTop === 0 && scroll < 0) {
        console.log("滑少了");
        topBar.style.backgroundColor = "transparent";
        topBar.style.position = "relative";
        topBar.style.borderBottom = "1px solid #f1f1f1";
        document.querySelector(".el-tabs__content").style.paddingTop = "0";
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/tabBar/tabBar.vue